import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicFormComponent } from "../../dynamic-form/dynamic-form.component";
import { CustomerManagementService } from "./customer-management.service";
import { FormControlBase } from "../../dynamic-form/form-control-base";
import { CustomerMergeFieldService } from "./customer-merge-field.service";
import { Customer } from "./customer";
import { Router } from "@angular/router";
import { AlertService } from "../../../services/index";
import { HttpClient } from '@angular/common/http';
import { NgModel } from '@angular/forms';

@Component({
    template: require('./customer-merge.html'),
    providers: [CustomerManagementService, CustomerMergeFieldService],
    styles: [require('../dynamic-form.css'), require('./customer-merge.css')]
})

export class CustomerMergeComponent implements OnInit {

    @ViewChild('toCustomerForm') toCustomerFormComponent: DynamicFormComponent;
    @ViewChild('fromCustomerForm') fromCustomerFormComponent: DynamicFormComponent;

    private fields: FormControlBase<any>[] = null;

    private fromCustomerTxt: string = "";
    private toCustomerTxt: string = "";

    private fromCustomer: Customer = null;
    private toCustomer: Customer = null;

    constructor(
        private customerMergeFieldService: CustomerMergeFieldService,
        private customerManagementService: CustomerManagementService,
        private router: Router,
        private alertService: AlertService,
        private http: HttpClient,
    ) {

    }

    ngOnInit() {
        this.fields = this.customerMergeFieldService.getFields();
        let self: CustomerMergeComponent = this;
    }

    private listFormatter(customer: Customer): string {
        let result = '';
        if (!customer) {
            return result;
        }
        if (customer.mobileNumber) {
            result += customer.mobileNumber;
        }
        if (customer.email) {
            result += (result == '' ? '' : ', ') + customer.email;
        }
        if (customer.firstName) {
            result += (result == '' ? '' : ', ') + customer.firstName;
        }
        if (customer.surname) {
            result += (result == '' ? '' : ' ') + customer.surname;
        }
        return result;
    }

    private toValueChanged(customer: Customer): void {
        if (!customer) {
            return;
        }
        let copy: any = this.copy(customer);
        this.toCustomerFormComponent.form.patchValue(copy);
    }

    private fromValueChanged(customer: Customer): void {
        if (!customer) {
            return;
        }
        let copy: any = this.copy(customer);
        this.fromCustomerFormComponent.form.patchValue(copy);
    }

    private copy(customer: Customer): any {
        return {
            firstName: customer.firstName,
            surname: customer.surname,
            mobileNumber: customer.mobileNumber,
            email: customer.email,
            externalId: customer.externalId
        };
    }

    private mergeCustomers(): void {
        let self: CustomerMergeComponent = this;
        this.customerManagementService.mergeCustomers(this.fromCustomer.userId, this.toCustomer.userId).subscribe(() => {
            self.router.navigate(['admin/customer-management']);
        }, error => self.alertService.error(error._body));
    }

    private clearToCustomer(): void {
        this.toCustomer = null;
        this.toCustomerFormComponent.form.reset();
    }

    private clearFromCustomer(): void {
        this.fromCustomer = null;
        this.fromCustomerFormComponent.form.reset();
    }

    private findFromCustomer(input: NgModel ) {
        let self = this;

        if (!input.valid) {
            self.alertService.error("Invalid input", false);
        }

        let searchTerm = this.getSearchTerm(this.fromCustomerTxt);

        this.http.post<any>('/api/users/search', searchTerm)
            .subscribe(data => {
                let customers: Array<Customer> = this.dataToCustomer(data);
                if (customers.length != 1) {
                    self.alertService.error("Invalid Search Term", false);
                }
                else {
                    self.alertService.success("From Customer found ", false);
                    self.fromCustomer = customers[0];
                    self.fromValueChanged(self.fromCustomer);
                }

            });
    }

    private findToCustomer(input: NgModel ) {
        let self = this;

        if (!input.valid) {
            self.alertService.error("Invalid input", false);
        }

        let searchTerm = this.getSearchTerm(this.toCustomerTxt);

        this.http.post<any>('/api/users/search', searchTerm)
            .subscribe(data => {
                let customers: Array<Customer> = this.dataToCustomer(data);
                if (customers.length != 1) {
                    self.alertService.error("Invalid Search Term", false);
                }
                else {
                    self.alertService.success("To Customer found ", false);
                    self.toCustomer = customers[0];
                    self.toValueChanged(self.toCustomer);
                }

            });

    }

    private dataToCustomer(data: any): Array<Customer> {
        let customers = new Array<Customer>();
        if (data == null) {
            return customers;
        }
        for (let d of data) {
            let customer = new Customer();
            customer.userId = d.UserId;
            customer.mobileNumber = d.MobileNumber;
            customer.email = d.Email;
            customer.firstName = d.FirstName;
            customer.surname = d.Surname;
            customer.externalId = d.ExternalId;
            customer.statusId = d.StatusId == 2;
            customers.push(customer);
        }
        return customers;
    }

    private getLastRefreshed(): Date {
        let lastRefreshed = new Date();
        if (lastRefreshed) {
            lastRefreshed = new Date(lastRefreshed.getTime() + -1 * (new Date().getTimezoneOffset() * 60000));
        }
        return lastRefreshed;
    }

    private getSearchTerm(mobileNumber: string) {
        let s =
        {
            "propertyName": "mobileNumber",
            "sortOrder": "DESC",
            "currentPage": 1,
            "itemsPerPage": 10,
            "updating": true,
            "mobileNumber": mobileNumber,
            "permissionsValue": 32,
            "mobileNumberCondition": 0,
            "lastRefreshed": this.getLastRefreshed()
        }
        return s;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/customer/customer-merge.component.ts